module.exports = __webpack_public_path__ + "97fdc7e600273a046484dcdc49f9d90f.svg";